module.exports = __webpack_public_path__ + "static/img/20.dbfce5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/20.png
// module id = wITp
// module chunks = 0